export default class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = null;
    this.productData = this.querySelector('[data-product-data]');
    this.addToCartButtons = this.querySelectorAll('data-add-to-cart');
    this.notifyMeButtons = this.querySelectorAll('data-notify-me');

    if (document.querySelector('cart-drawer')) {
      this.addToCartButtons.forEach((button) => {
        button.setAttribute('aria-haspopup', 'dialog');
      });
    }
  }

  connectedCallback() {
    this.productOptionSelectors = this.querySelectorAll(
      '[data-target="options"]',
    );

    this.form = this.querySelector('form');

    this.productJSON = this.productData
      ? JSON.parse(this.productData.textContent)
      : null;

    this.variants = this.productJSON.variants;
    this.options = this.productJSON.options;
    this.quantity = this.querySelector('[data-quantity-input]');

    this.form.addEventListener('form:change', (event) => this.validate(event));
    this.form.addEventListener('load', (event) => this.validate(event));
    this.form.addEventListener('submit', (event) => this.handleAddToBag(event));
  }

  disconnectedCallback() {
    this.form.removeEventListener('form:change', this.validate);
    this.form.removeEventListener('load', this.validate);
    this.form.removeEventListener('submit', this.handleAddToBag);
  }

  updateURL(variantId) {
    if (!variantId || this.dataset.updateUrl === 'false') return;
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${variantId}`,
    );
  }

  getActiveVariant() {
    const formData = this.serializeForm();
    const formOptions = {
      option1: null,
      option2: null,
      option3: null,
    };
    let selectedVariant = null;

    const formHasOptions = formData.some(
      (item) => item.name.indexOf('option') !== -1,
    );

    if (formHasOptions) {
      formData.forEach((item) => {
        if (item.name.indexOf('option') !== -1) {
          formOptions[item.name] = item.value;
        }
      });

      this.variants.forEach((variant) => {
        if (
          variant.option1 === formOptions.option1 &&
          variant.option2 === formOptions.option2 &&
          variant.option3 === formOptions.option3
        ) {
          selectedVariant = variant;
        }
      });
    } else {
      // eslint-disable-next-line prefer-destructuring
      selectedVariant = this.variants[0];
    }

    return selectedVariant;
  }

  serializeForm() {
    const formData = new FormData(this.form);
    const serializedArray = [];

    for (const [name, value] of formData.entries()) {
      serializedArray.push({ name, value });
    }

    return serializedArray;
  }

  validate(event) {
    const hasVariant = event?.detail !== null;
    const canAddToCart = hasVariant && event?.detail?.available === true;
    const inputId = this.querySelector('[data-target="variant-id"]');
    const price = this.querySelectorAll('[data-target="product-price"]');
    let formattedVariantPrice;
    let comparePrice;
    let priceHtml;

    inputId.value = event?.detail?.id;

    if (hasVariant) {
      formattedVariantPrice = `$${event.detail.price / 100}`;
      comparePrice = event.detail.compare_at_price
        ? `$${(event.detail.compare_at_price / 100).toFixed(0)}`
        : false;

      priceHtml = `
        <span
          class='body-2'
          data-target='product-price'
        >
          <span
            data-target='compare-price'
            class='body-2 ${!comparePrice ? 'hidden' : ''}'
          >
            <span class='body-2 line-through'>${comparePrice}</span>
          </span>
          <span class="${comparePrice ? 'ml-1.5 font-bold' : ''}">
          ${formattedVariantPrice} 
          </span>
        </span>`;

      if (window.location.pathname.includes('/products/')) {
        this.updateURL(event?.detail?.id);
      }
    } else {
      priceHtml = price.dataset.defaultPrice;
    }

    price.forEach((item) => {
      const el = item;
      el.innerHTML = priceHtml;
    });

    if (canAddToCart) {
      this.addToCartButtons.forEach((button) => {
        button.classList.remove('hidden');
      });
      this.notifyMeButtons.forEach((button) => {
        button.classList.add('hidden');
      });
    } else {
      this.addToCartButtons.forEach((button) => {
        button.classList.add('hidden');
      });
      this.notifyMeButtons.forEach((button) => {
        button.classList.remove('hidden');
      });
    }
  }

  handleAddToBag(event) {
    event.preventDefault();
    event.stopPropagation();
    const activeVariant = this.getActiveVariant();
    const canAddToCart = activeVariant.available;

    if (!canAddToCart) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
      return;
    }

    const formData = new FormData(this.form);

    const originalProductQuantity = formData.get('quantity');

    const payload = {
      merchandiseId: `${activeVariant.id}`,
      quantity: originalProductQuantity,
    };

    const cartItems = document.querySelector('cart-drawer-items');
    cartItems.addToCart(payload);
  }
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', ProductForm);
}
